export default __webpack_public_path__ + "static/media/585.b85eeed0.png";